import { Suspense, useEffect } from 'react';
import { Spin } from 'antd';
import { cookieUtils } from 'helpers/cookiesUtils';
import Routing from './Routing';
import RoutingGuest from './RoutingGuest';
import RoutingTherapist from './RoutingTherapist';
import ScrollToTop from './components/scroll-to-top/ScrollToTop';

const { getCookies } = cookieUtils;
const cookies = getCookies();
function AppRoutes() {

    useEffect(() => {
        if (!cookies && window.location.pathname !== '/auth' && window.location.pathname?.includes('admin')) {
            window.location.href = '/auth';
        } else if (!cookies && window.location.pathname !== '/auth-therapist' && window.location.pathname?.startsWith('/therapist/')) {
            window.location.href = '/auth-therapist';
        }
    }, [cookies, window.location.pathname]);

    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<Spin />}>
                <RoutingGuest />
                {cookies && (
                    <>
                        <RoutingTherapist />
                        <Routing />
                    </>
                )}

            </Suspense>
        </>
    );
}

export default AppRoutes;
